import { useEffect, useState } from 'react';
import api from '../../api';

function SiteSettings() {
  const [settings, setSettings] = useState({
    site_name: '',
    site_tagline: '',
    main_page_intro: '',
    contact_email: '',
    contact_phone: '',
    contact_phone_landline: '',
    contact_address: '',
    footer_contact_heading: '',
    footer_hours_heading: '',
    footer_hours_text: '',
    footer_bottom_text: ''
  });
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState({ type: '', text: '' });

  useEffect(() => {
    api.get('/api/admin/settings')
      .then(res => {
        const siteSettings = {};
        ['site_name', 'site_tagline', 'main_page_intro', 'contact_email', 'contact_phone', 'contact_phone_landline', 'contact_address', 'footer_contact_heading', 'footer_hours_heading', 'footer_hours_text', 'footer_bottom_text'].forEach(key => {
          if (res.data[key] !== undefined) {
            siteSettings[key] = res.data[key];
          }
        });
        setSettings(prev => ({ ...prev, ...siteSettings }));
      })
      .catch(err => console.error('Failed to fetch settings:', err))
      .finally(() => setLoading(false));
  }, []);

  const handleSave = async () => {
    setSaving(true);
    setMessage({ type: '', text: '' });

    try {
      await api.put('/api/admin/settings', settings);
      setMessage({ type: 'success', text: 'Settings saved successfully!' });
    } catch (err) {
      setMessage({ type: 'error', text: err.response?.data?.error || 'Failed to save settings' });
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return <div className="loading">Loading settings...</div>;
  }

  return (
    <div>
      <div className="admin-header">
        <h1>Site Settings</h1>
        <button onClick={handleSave} className="btn btn-primary" disabled={saving}>
          {saving ? 'Saving...' : 'Save Changes'}
        </button>
      </div>

      {message.text && (
        <div className={`message ${message.type}`}>{message.text}</div>
      )}

      <div style={{ maxWidth: '600px' }}>
        <div style={{ backgroundColor: 'var(--background-secondary)', padding: '20px', borderRadius: '8px', marginBottom: '20px' }}>
          <h3 style={{ marginBottom: '20px' }}>General</h3>

          <div className="form-group">
            <label>Site Name</label>
            <input
              type="text"
              value={settings.site_name}
              onChange={e => setSettings({ ...settings, site_name: e.target.value })}
              placeholder="Wedding Attire"
            />
          </div>

          <div className="form-group">
            <label>Home page tagline (text under the site name)</label>
            <input
              type="text"
              value={settings.site_tagline}
              onChange={e => setSettings({ ...settings, site_tagline: e.target.value })}
              placeholder="Com 35 anos de experiência no mundo da moda masculina"
            />
          </div>

          <div className="form-group">
            <label>Main Page Intro (store information shown on homepage)</label>
            <textarea
              value={settings.main_page_intro}
              onChange={e => setSettings({ ...settings, main_page_intro: e.target.value })}
              placeholder="Welcome text and store information..."
              rows={5}
            />
          </div>
        </div>

        <div style={{ backgroundColor: 'var(--background-secondary)', padding: '20px', borderRadius: '8px' }}>
          <h3 style={{ marginBottom: '20px' }}>Contact Information</h3>

          <div className="form-group">
            <label>Email</label>
            <input
              type="email"
              value={settings.contact_email}
              onChange={e => setSettings({ ...settings, contact_email: e.target.value })}
              placeholder="contact@example.com"
            />
          </div>

          <div className="form-group">
            <label>Mobile phone (telemóvel)</label>
            <input
              type="tel"
              value={settings.contact_phone}
              onChange={e => setSettings({ ...settings, contact_phone: e.target.value })}
              placeholder="+351 912 345 678"
            />
          </div>

          <div className="form-group">
            <label>Landline phone (telefone fixo)</label>
            <input
              type="tel"
              value={settings.contact_phone_landline}
              onChange={e => setSettings({ ...settings, contact_phone_landline: e.target.value })}
              placeholder="+351 223 456 789"
            />
          </div>

          <div className="form-group">
            <label>Address</label>
            <textarea
              value={settings.contact_address}
              onChange={e => setSettings({ ...settings, contact_address: e.target.value })}
              placeholder="123 Wedding Street&#10;Porto, Portugal"
              rows={3}
            />
          </div>
        </div>

        <div style={{ backgroundColor: 'var(--background-secondary)', padding: '20px', borderRadius: '8px', marginTop: '20px' }}>
          <h3 style={{ marginBottom: '20px' }}>Footer (rodapé)</h3>

          <div className="form-group">
            <label>Contact section heading (título da secção contacto)</label>
            <input
              type="text"
              value={settings.footer_contact_heading}
              onChange={e => setSettings({ ...settings, footer_contact_heading: e.target.value })}
              placeholder="Contacto"
            />
          </div>

          <div className="form-group">
            <label>Hours section heading (título da secção horário)</label>
            <input
              type="text"
              value={settings.footer_hours_heading}
              onChange={e => setSettings({ ...settings, footer_hours_heading: e.target.value })}
              placeholder="Horário"
            />
          </div>

          <div className="form-group">
            <label>Hours text (uma linha por período)</label>
            <textarea
              value={settings.footer_hours_text}
              onChange={e => setSettings({ ...settings, footer_hours_text: e.target.value })}
              placeholder={'Segunda a sexta: 10h – 19h\nSábado: 10h – 17h\nDomingo: Sob marcação'}
              rows={4}
            />
          </div>

          <div className="form-group">
            <label>Bottom line text (texto no final do rodapé)</label>
            <input
              type="text"
              value={settings.footer_bottom_text}
              onChange={e => setSettings({ ...settings, footer_bottom_text: e.target.value })}
              placeholder="Todos os direitos reservados."
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default SiteSettings;
